import React, { useState } from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";

import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { BiFilter } from "react-icons/bi";
type Options = {
  courseOptions: any[];
  levelOptions: any[];
  subjectOptions: any[];
  facultyOptions: any[];
  groupOptions: any[];
  moduleOptions: any[];
  modeOptions: any[];
  categoryOptions: any[];
  syllabusOptions: any[];
  instituteOptions: any[];
};

type FilterValues = {
  course: string;
  level: string;
  subject: string;
  faculty: string;
  group: string;
  module: string;
  mode: string;
  category: string;
  syllabus: string;
  institute: string;
};

type Props = {
  options: Options;
  filterValues: FilterValues;
  setFilterValues: (fieldName: string, value: string) => void;
  isOptionLoading: boolean;
  onSearch: () => void;
  isProductLoading: boolean;
};

const ProductFilterDialog = ({
  options,
  filterValues,
  setFilterValues,
  isOptionLoading,
  onSearch,
  isProductLoading,
}: Props) => {
  const [open, setOpen] = useState({
    filter: true,
  });
  const toggle = (key: keyof typeof open) => {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className=" flex flex-col ">
      <div className="flex justify-between items-center sticky top-0 z-50">
        <div
          onClick={() => toggle("filter")}
          className="text-xl cursor-pointer font-medium flex gap-1"
        >
          <BiFilter size={30} /> Filter{" "}
        </div>
      </div>
      {open.filter && (
        <div className="z-50 xs:h-36 md:h-60  2xl:h-52  overflow-auto flex flex-col gap-1 p-3">
          <div className="flex gap-3 flex-wrap">
            <div>
              <ATMSelect
                placeholder="select course"
                name=""
                isLoading={isOptionLoading}
                options={options.courseOptions}
                value={
                  options.courseOptions?.find(
                    (course) => course.value === filterValues.course
                  ) || null
                }
                onChange={(newValue) => {
                  setFilterValues("course", newValue?.value || "");
                }}
                label="Course Name"
                disabled={isOptionLoading}
              />
            </div>
            <div>
              <ATMSelect
                placeholder="select level"
                name=""
                isLoading={isOptionLoading}
                options={options.levelOptions}
                value={
                  options.levelOptions?.find(
                    (level) => level.value === filterValues.level
                  ) || null
                }
                onChange={(newValue) =>
                  setFilterValues("level", newValue?.value || "")
                }
                label="Level Name"
              />
            </div>
            <div>
              <ATMSelect
                isLoading={isOptionLoading}
                name={``}
                label="Subject"
                options={options.subjectOptions}
                onChange={(newValue) => {
                  setFilterValues(`subject`, newValue?.value || "");
                }}
                value={
                  options.subjectOptions?.find(
                    (sub) => sub.value === filterValues.subject
                  ) || null
                }
              />
            </div>

            <div>
              <ATMSelect
                isLoading={isOptionLoading}
                name={``}
                label="Faculty"
                options={options.facultyOptions}
                onChange={(newValue: any) => {
                  setFilterValues(`faculty`, newValue?.value || "");
                }}
                value={
                  options.facultyOptions?.find(
                    (fac) => fac.value === filterValues.faculty
                  ) || null
                }
              />
            </div>
            <div>
              <ATMSelect
                isLoading={isOptionLoading}
                name={``}
                label="Institute"
                options={options.instituteOptions}
                onChange={(newValue: any) => {
                  setFilterValues(`institute`, newValue?.value || "");
                }}
                value={
                  options.instituteOptions?.find(
                    (fac) => fac.value === filterValues.institute
                  ) || null
                }
              />
            </div>
            <div>
              <ATMSelect
                placeholder="select module"
                name=""
                isLoading={isOptionLoading}
                options={options.moduleOptions}
                value={
                  options.moduleOptions?.find(
                    (module) => module.value === filterValues.module
                  ) || null
                }
                onChange={(e) => {
                  setFilterValues("module", e?.value || "");
                }}
                label="Module Name"
              />
            </div>
            <div>
              <ATMSelect
                placeholder="select group"
                name=""
                isLoading={isOptionLoading}
                options={options.groupOptions}
                value={
                  options.groupOptions?.find(
                    (group) => group.value === filterValues.group
                  ) || null
                }
                onChange={(e) => {
                  setFilterValues("group", e?.value || "");
                }}
                label="Group Name"
              />
            </div>
            <div>
              <ATMSelect
                placeholder="select syllabus"
                name=""
                isLoading={isOptionLoading}
                options={options.syllabusOptions}
                value={
                  options.syllabusOptions?.find(
                    (syl) => syl.value === filterValues.syllabus
                  ) || null
                }
                onChange={(e) => {
                  setFilterValues("syllabus", e?.value || "");
                }}
                label="Syllabus Name"
              />
            </div>
            <div>
              <ATMSelect
                placeholder="select mode"
                name=""
                isLoading={isOptionLoading}
                options={options.modeOptions}
                value={
                  options.modeOptions?.find(
                    (mode) => mode.value === filterValues.mode
                  ) || null
                }
                onChange={(e) => {
                  setFilterValues("mode", e?.value || "");
                }}
                label="Mode Name"
              />
            </div>
            <div>
              <ATMSelect
                placeholder="select category"
                name=""
                isLoading={isOptionLoading}
                options={options.categoryOptions}
                value={
                  options.categoryOptions?.find(
                    (cate) => cate.value === filterValues.category
                  ) || null
                }
                onChange={(e) => {
                  setFilterValues("category", e?.value || "");
                }}
                label="Category Name"
              />
            </div>
          </div>
          <div className="flex justify-end self-end">
            <ATMLoadingButton
              disabled={isProductLoading}
              onClick={onSearch}
              type="submit"
            >
              Apply
            </ATMLoadingButton>
          </div>{" "}
        </div>
      )}
    </div>
  );
};

export default ProductFilterDialog;
